/**
 * @flow
 * @relayHash 20d675ced95c59fbbd820dd36cd89679
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePlaylistInput = {
  clientMutationId?: ?string,
  id: string,
};
export type Playlists_deletePlaylistMutationVariables = {|
  input: DeletePlaylistInput
|};
export type Playlists_deletePlaylistMutationResponse = {|
  +deletePlaylist: ?{|
    +deletedPlaylistId: ?string
  |}
|};
export type Playlists_deletePlaylistMutation = {|
  variables: Playlists_deletePlaylistMutationVariables,
  response: Playlists_deletePlaylistMutationResponse,
|};
*/


/*
mutation Playlists_deletePlaylistMutation(
  $input: DeletePlaylistInput!
) {
  deletePlaylist(input: $input) {
    deletedPlaylistId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePlaylistInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deletePlaylist",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "DeletePlaylistInput!"
      }
    ],
    "concreteType": "DeletePlaylistPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "deletedPlaylistId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "Playlists_deletePlaylistMutation",
  "id": null,
  "text": "mutation Playlists_deletePlaylistMutation(\n  $input: DeletePlaylistInput!\n) {\n  deletePlaylist(input: $input) {\n    deletedPlaylistId\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Playlists_deletePlaylistMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "Playlists_deletePlaylistMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '16cdbe49da84c71074e3088da4277e76';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/App/__generated__/Playlists_deletePlaylistMutation.graphql.js